function isInElectron() {
    if (/electron=true/.test(window.location.href)) {
        return true;
    }

    return false;
}

$(document).ready(function(){   

      /*   $('.terminal-left').height($('.terminal-content-tab').height() + $('.terminal-tabs').height());

        $( window ).resize(function() {
            $('.terminal-left').height($('.terminal-content-tab').height() + $('.terminal-tabs').height());
        });
      */

        // DISABLED
        // updateResults();

        $('#betting-btn').click(function(){
                showNumpad( $(this));
        });

        $('#quick-lucky-balls').click(function(){
            $('#random-six-button').click();
            $('#buy-ticket-button').click();
        });
        
        if (isInElectron()) {
            $('body').click(function(){
                window.parent.postMessage({
                    eventName: 'last_click',
                    data: ''
                }, 'file://');
            });
            $('body').addClass('electron-true');
        }
    });

    document.onkeydown = function(event) {
        if (isInElectron()) {
            if (event.which == '13') {
                event.preventDefault();
            }
        }
    }

function showNumpad(elem){

    $('.numpad-overlay').click(function(){
        hideNumpad();
    })

    selectedNums = false;
    var total = 0;
    var arrValue = [];

    $('#numpad-title').text('Payment');
    $('#numpad-title-value').text($('#betting-btn').val());

    $('*[data-predefined]').click(function(){
        selectedNums = false;
        arrValue = [];
        value = $(this).data('value');
        $('#numpad-title-value').text(Number(value).toFixed(2));
        $('#num-value').val(Number(value).toFixed(2));
    });

    $('*[data-num]').click(function(){
        if(!selectedNums){
            value = 0;
        }
        selectedNums = true;
        value = $(this).data('num');

        // Allow only two decimal places
        if ((total % 1) != 0 && $(this).data('numpad') != 'delete') {
            if(total.toString().split(".")[1].length == 2){
                return false;
            }
        }

        // Check if decimal place exist in array
        if($(this).data('num') === '.') {
            if(total == 0){
                return false;
            }
            if($.inArray(value, arrValue) >= 0) {
                return false;
            }
        }

        if($(this).data('numpad') == 'value'){
            if(total == 0 && value == 0){
                return false;
            }
            arrValue.push(value);
            total = arrValue.join(""); 
        }

        if($(this).data('numpad') == 'delete'){
            arrValue.splice(-1,1)
            total = arrValue.length == 0 ? 0 : arrValue.join(""); 
        }

        $('#numpad-title-value').text(Number(total).toFixed(2));
        $('#num-value').val(Number(total).toFixed(2));

        console.log(arrValue)
    })

    elem.blur();
    $('.numpad-overlay').show();
    $('#numpad').show();

    $('#numpad-ok').click(function(){
        $('#betting-btn').val($('#num-value').val());
        hideNumpad();
    });

    $('#numpad-buy').click(function(){
        $('#betting-btn').val($('#num-value').val());
        hideNumpad();
        $('#buy-ticket-button').click()
    });

    $(document).keydown(function(event) {
        console.log(event.key);
        switch (event.key) {
            case 'Enter':
                !isInElectron() ? $('#numpad-ok').click() : event.preventDefault();
                break;
            case '1':
                $('*[data-num="1"]').click();
                break;
            case '2':
                $('*[data-num="2"]').click();
                break;
            case '3':
                $('*[data-num="3"]').click();
                break;
            case '4':
                $('*[data-num="4"]').click();
                break;
            case '5':
                $('*[data-num="5"]').click();
                break;
            case '6':
                $('*[data-num="6"]').click();
                break;
            case '7':
                $('*[data-num="7"]').click();
                break;
            case '8':
                $('*[data-num="8"]').click();
                break;
            case '9':
               $('*[data-num="9"]').click();
                break;
            case '0':
                $('*[data-num="0"]').click();
                break;
            case '.':
                $('*[data-num="."]').click();
                break;
            case ',':
                $('*[data-num="."]').click();
                break;
            case 'Backspace':
                $('*[data-num="delete"]').click();
                break;
        }
    });
}

function hideNumpad(){
    $('.numpad-overlay').hide();
    $('#numpad').hide();
}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/terminal.js
// module id = 851
// module chunks = 2